import { useEffect, FC } from "react";
import { useLocation } from "react-router-dom";

interface PagePros {
  title: string;
  component: FC
}

const Page = ({ title, component }: PagePros) => {
  const location = useLocation();
  const PageComponent = component;

  useEffect(() => {
    document.title = title;
  }, [location, title]);

  return <PageComponent />;
};

export default Page;
